module.exports = new __parcel__URL__("C5O1.dd092234.png").toString();